{
  "add_prefix_space": false,
  "bos_token": "<EOT>",
  "clean_up_tokenization_spaces": true,
  "eos_token": "<EOT>",
  "model_max_length": 200000,
  "tokenizer_class": "ClaudeTokenizer",
  "unk_token": "<EOT>"
}